import { render, staticRenderFns } from "./BKCheckbox.vue?vue&type=template&id=51d7e791"
import script from "./BKCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./BKCheckbox.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports